import Phaser from "phaser";
import UiInterface from "./UiInterface";
import Tracking from "./Tracking";
import Pqp from "../../3x1010/Pqp";
import ProgressBar from "./ProgressBar";
import PagePlayer from "../PagePlayer";
import PanelCameras from "./PanelCameras";
import Panel3D from "./Panel3D";
import PanelReport from "./PanelReport";
import Background from "phaser3-rex-plugins/plugins/gameobjects/dynamictext/dynamictext/bob/background/Background";
import Locale from "../../3x1010/Locale";

export default class MainScene extends Phaser.Scene {
  constructor() {
    super({ key: "MainScene" });
    MainScene.that = this;
    this.toClean = [];
    //this.appConfig = Tracking.appConfig;
    this.videoPaused = true;
    this.flagBound = false;
    this.flagManequin = true;
    this.flagStats = true;
    this.videoStarted = false;
    this.currentSpeed = 1;
    this.idto = null;
    this.disabler = null;
    this.videoAnalisi = false;
    this.performAlreadyShown = [];
    this.dataSelected = null;
    //this.setSelectedVideo(Tracking.data.selected);
    this.setSelectedVideo(0);
    if (Tracking.appConfig.hand === "True") {
      if (jQuery("#sel-exercise").prop("selectedIndex") === 0) {
        this.setSelectedVideo(2);
      } else if (jQuery("#sel-exercise").prop("selectedIndex") === 1) {
        this.setSelectedVideo(0);
      } else {
        this.setSelectedVideo(2);
      }
    } else {
      if (jQuery("#sel-exercise").prop("selectedIndex") === 0) {
        this.setSelectedVideo(0);
      } else if (jQuery("#sel-exercise").prop("selectedIndex") === 1) {
        this.setSelectedVideo(2);
      } else {
        this.setSelectedVideo(0);
      }
    }
    //debugger;

    ///debugger;
    //console.log(Tracking.data.selected);
    //this.setSelectedVideo(3);
    this.pressedSwitch = false;
    this.alreadyPaused = false;
    this.hiPerformance = true;
    this.tweenPanelActive = false;
    this.status3D = 0;
    this.statusPanel = 0;
    this.statusReport = 0;
    this.singleStats = [];
    //console.log(Tracking.data);
    //debugger;

    //this.setupPloty();
  }

  setSelectedVideo(selected) {
    this.selected = selected;
    this.dataSelected = Tracking.data.videos[selected];
  }

  preload() {
    const txt = this.add.text(0, 720, "0%", {
      fontFamily: "DIN Next LT Pro",
      fontWeight: 200,
      fontSize: "20px",
      color: this.toHexColor(ProgressBar.COLOR_LABELS),
      align: "center",
      fixedWidth: 1920,
    });
    txt.setOrigin(0, 0);
    this.txtWait = txt;
    //this.txtWait.visible = false;
    //console.log(this.dataSelected.url);
    const curIndex = this.selected;

    this.loading = this.add.sprite(Tracking.WIDTH / 2, Tracking.HEIGHT / 2, "loading");
    this.loading.anims.play("preload");
    //debugger;

    const tmp = Tracking.data.videos[curIndex].url.split("/");
    //document.querySelector(".js-video-name").innerText = "(video: " + tmp[tmp.length - 1] + ")";
    //document.querySelector('.js-video-name').innerText = '';

    /*for (let x = 0; x < Tracking.data.videos.length; x++) {
      this.load.video("camera" + x, Tracking.data.videos[x].url, "loadeddata", false, false);
    }*/

    this.load.video("camera" + curIndex, Tracking.data.videos[curIndex].url, "canplay", false, false);
    Tracking.data.videos[curIndex].cached = true;

    for (let x = 0; x < MainScene.tiles.length; x++) {
      this.load.spritesheet(MainScene.tiles[x].id, MainScene.tiles[x].url, MainScene.tiles[x].config);
    }
    for (let x = 0; x < MainScene.images.length; x++) {
      this.load.image(MainScene.images[x].id, MainScene.images[x].url);
    }

    this.load.on("progress", this.onProgress.bind(this));
  }

  onProgress(e) {
    this.txtWait.setText(Math.floor(e * 100) + "%");
  }

  create() {
    for (let x = 0; x < PanelCameras.CAMERAS.length; x++) {
      const { id } = PanelCameras.CAMERAS[x];
      this.anims.create({
        key: id + "_off",
        frames: this.anims.generateFrameNumbers(id, { frames: [0] }),
        frameRate: 1,
        repeat: 0,
      });
      this.anims.create({
        key: id + "_on",
        frames: this.anims.generateFrameNumbers(id, { frames: [1] }),
        frameRate: 1,
        repeat: 0,
      });
    }

    this.load.off("progress");
    console.log("CREATED");
    this.game.input.mouse.preventDefaultWheel = false;
    setTimeout(this.doCreate.bind(this), 500);
  }

  doCreate() {
    this.loading.visible = false;
    this.txtWait.visible = false;
    this.createVideo();

    this.createInterface();
    this.ui.setPlayPause(false);
    this.createButtonStart();
    this.createLogo();
    this.createPlayPauseBig();
    this.createDisabler();
    this.createDisablerAnalisi();
  }

  createVideo() {
    const vid = this.add.video(0, 0, "camera" + this.selected);
    vid.setOrigin(0, 0);
    /*if (MainScene.AUTO_START) {
      this.videoStarted = true;
      vid.play(true);
    }*/
    this.vid = vid;
    this.every = (this.vid.getDuration() * 1000) / this.dataSelected.data[0].length;
    this.every = 1000 / MainScene.FPS;
    this.vid.setInteractive();
    this.vid.on("pointerup", this.togglePlayPause.bind(this));

    vid.on("complete", () => {
      this.ui.progressBar.outJumpBar();
      this.vid.play();
      this.performAlreadyShown = [];
    });

    vid.on("created", () => {
      vid.setDisplaySize(1920, 1080);
    });

    PagePlayer.that.getDimensions();
    try {
      vid.setDisplaySize(1920, 1080);
    } catch (e) {
      this.setVideoDimensions();
    }
  }

  setVideoDimensions() {
    try {
      vid.setDisplaySize(1920, 1080);
    } catch (e) {
      setTimeout(this.setVideoDimensions.bind(this), 100);
    }
  }

  createInterface() {
    this.ui = new UiInterface(this, this.handleInterfaceEvents.bind(this));
    this.ui.init();
    this.add.existing(this.ui);
    this.ui.x = 0;
    this.ui.y = Tracking.HEIGHT - UiInterface.HEIGHT;
  }

  invalidateAndRedraw() {
    this.lastMannequin = undefined;
    this.lastBoundingRect = undefined;
  }

  handleInterfaceEvents(e) {
    this.invalidateAndRedraw();
    if (e.type === UiInterface.EVENT_PAUSE) {
      this.pauseVideo();
    } else if (e.type === UiInterface.EVENT_RESUME) {
      this.resumeVideo();
    } else if (e.type === UiInterface.EVENT_MOVED_KNOB) {
      this.movedKnob(e.data);
    } else if (e.type === UiInterface.EVENT_SHOW_VIDEO) {
      this.showVideo(e.data);
    } else if (e.type === UiInterface.EVENT_SHOW_BOUND) {
      this.showBound(e.data);
    } else if (e.type === UiInterface.EVENT_SHOW_MANEQUIN) {
      this.showManequin(e.data);
    } else if (e.type === UiInterface.EVENT_SHOW_STATS) {
      this.showStats(e.data);
    } else if (e.type === UiInterface.EVENT_PERFORMANCE) {
      this.togglePerformance(e.data);
    } else if (e.type === UiInterface.EVENT_GOX1) {
      this.gox1();
    } else if (e.type === UiInterface.EVENT_GOX5) {
      this.gox5();
    } else if (e.type === UiInterface.EVENT_GOX10) {
      this.gox10();
    } else if (e.type === UiInterface.EVENT_SHOW_ANALISI) {
      this.checkAnalisi(e.data);
    }
  }

  togglePerformance(flag) {
    this.hiPerformance = flag;
  }

  showVideo(flag) {
    if (flag) {
      this.vid.alpha = 1;
    } else {
      this.vid.alpha = 0.1;
    }
  }

  showBound(flag) {
    this.flagBound = flag;
    this.drawData();
  }

  showManequin(flag) {
    this.flagManequin = flag;
    this.drawData();
  }

  showStats(flag) {
    this.flagStats = flag;
    this.drawData();

    if (!this.flagStats) {
      if (this.statPanel) {
        this.statPanel.destroy();
        this.statPanel = null;
      }
    } else {
      try {
        const perc = this.vid.getCurrentTime() / this.vid.getDuration();
        this.ui.setBar(perc, this.getTime(perc));
        this.writeStats2(perc);
      } catch (e) {}
    }
  }

  togglePlayPause() {
    if (this.reportOpened) {
      return;
    }

    if (this.tweenPanelActive) {
      return;
    }

    if (this.status3D === 1) {
      return;
    }

    /*if (this.currentSpeed !== 1) {
      return;
    }*/

    if (!this.checkVideoStarted()) {
      return;
    }

    if (this.vid.isPaused()) {
      this.playPauseEffect(false);
      this.resumeVideo();
    } else {
      this.playPauseEffect(true);
      this.pauseVideo();
    }
  }

  playPauseEffect(lPause) {
    let button = this.bigPlay;
    if (lPause) {
      button = this.bigPause;
    }
    //this.children.bringToTop(button);

    button.visible = true;
    button.alpha = 1;
    button.setScale(0.25, 0.25);

    this.tweens.add({
      targets: button,
      scaleX: 0.5,
      scaleY: 0.5,
      alpha: 1,
      duration: 250,
      onComplete: this.hideButton.bind(this, button),
    });
  }

  hideButton(button) {
    button.visible = false;
  }

  checkVideoStarted() {
    if (!this.videoStarted) {
      this.videoPaused = false;
      this.videoStarted = true;
      this.vid.play();
      this.ui.setPlayPause(true);
      return false;
    }
    return true;
  }

  pauseVideo() {
    if (!this.checkVideoStarted()) {
      return;
    }

    this.videoPaused = true;
    this.vid.setPaused(true);
    //  if (this.currentSpeed === 1) {
    this.ui.setPlayPause(false);
    //}
  }

  resumeVideo() {
    if (!this.checkVideoStarted()) {
      return;
    }

    this.videoPaused = false;
    this.vid.setPaused(false);

    //  if (this.currentSpeed === 1) {
    this.ui.setPlayPause(true);
    //    }
  }

  getTime(percent) {
    const dur = this.vid.getDuration();
    return dur * percent;
  }

  movedKnob(data) {
    this.ui.setBar(data.percent, this.getTime(data.percent));
    this.writeStats2(data.percent);
    this.drawData();
    if (data.seek) {
      this.vid.off("seeked");
      this.vid.on("seeked", this.vidoeSeeked.bind(this));
      this.vid.seekTo(data.percent);
    }
  }

  vidoeSeeked() {
    this.vid.off("seeked");
    this.drawData();
  }

  update() {
    if (!this.videoPaused) {
      this.drawData();
      if (this.ui) {
        const perc = this.vid.getCurrentTime() / this.vid.getDuration();
        this.ui.setBar(perc, this.getTime(perc));
        this.writeStats2(perc);

        if (this.videoAnalisi) {
          this.checkIfShowPerform();
        }
      }
    }
    this.ui?.progressBar?.zoomPanel?.updateGlobalFaseLabel();

    if (this.ui?.progressBar?.zoomPanel?.additionalInfo) {
      const info = this.ui.progressBar.zoomPanel.additionalInfo;
      if (this.statPanel) {
        if (info.height + info.y > this.statPanel.y) {
          this.statPanel.x = info.x + info.width + 16;
          this.statPanel.y = info.y;
          //console.log(this.statPanel.width);
          while (this.statPanel.x + this.statPanel.width + 16 > Tracking.WIDTH) {
            this.statPanel.x = Tracking.WIDTH - this.statPanel.width - 16;
          }
          //console.log("Sposto");
        } else {
          this.statPanel.x = 16;
          this.statPanel.y = 360;
        }
      }
    } else {
      if (this.statPanel) {
        this.statPanel.x = 16;
        this.statPanel.y = 360;
      }
    }

    if (this.statPanel && this.logo) {
      if (this.statPanel.x + this.statPanel.width > this.logo.x) {
        this.logo.visible = false;
      } else {
        this.logo.visible = true;
      }
    } else {
      if (this.logo) {
        this.logo.visible = true;
      }
    }
  }

  drawData() {
    const playbackTime = this.vid.getCurrentTime() * 1000;
    const toShow = Math.floor(playbackTime / this.every);
    this.lastToShow = toShow;

    //console.log(playbackTime);

    if (!this.hiPerformance) {
      if (toShow % 3 !== 0) {
        return;
      }
    }

    let lRedraw;
    if (this.flagBound) {
      lRedraw = this.drawBoundingRectangle(this.dataSelected.data[0][toShow]);
    }
    if (lRedraw) {
      if (this.flagManequin) {
        this.drawMannequin(this.dataSelected.data[1][toShow], false);
      }
    } else {
      if (!this.flagBound) {
        if (this.flagManequin) {
          if (this.dataSelected.data[1].length > 0) {
            lRedraw = this.drawMannequin(this.dataSelected.data[1][toShow], true);
          } else {
            this.clean();
          }
        }
      }
    }
    //debugger;
    //this.writeStats(this.dataSelected.data[5][toShow], this.dataSelected.data[0][toShow]);

    if (!this.flagBound && !this.flagManequin) {
      this.clean();
    }

    if (!lRedraw) {
      // console.log("skipped");
    }

    /*this.children.bringToTop(this.bigPause);
    this.children.bringToTop(this.bigPlay);
    this.children.bringToTop(this.disabler);
    this.children.bringToTop(this.loading);
    this.children.bringToTop(this.txtWait);*/

    if (this.bigPause) {
      this.bigPause.setDepth(11000);
      this.bigPlay.setDepth(11001);
      this.disabler.setDepth(11012);
      this.loading.setDepth(11013);
      this.txtWait.setDepth(11014);
      //if (Tracking.data.videos.length > 1) {
      //this.stats.setDepth(10004);
      this.disablerAnalisi.setDepth(10005);
      this.togglecam.setDepth(10006);
      this.togglepanel3d.setDepth(10007);
      this.report.setDepth(10008);

      //}
    }
  }

  drawBoundingRectangle(data) {
    let lRedraw = false;
    if (!data) {
      return lRedraw;
    }
    if (!this.lastBoundingRect) {
      this.lastBoundingRect = [-1, -1, -1, -1];
    }

    if (data[0] !== this.lastBoundingRect[0] || data[1] !== this.lastBoundingRect[1] || data[2] !== this.lastBoundingRect[2] || data[3] !== this.lastBoundingRect[3]) {
      this.lastBoundingRect = [data[0], data[1], data[2], data[3]];
      lRedraw = true;
    }

    if (lRedraw) {
      let spanRatiox = 1920 / MainScene.REAL_VIDEO_WIDTH;
      let spanRatioy = 1080 / MainScene.REAL_VIDEO_HEIGHT;

      this.clean();

      const rect = this.add.rectangle(data[0] * spanRatiox, data[1] * spanRatioy, data[2] * spanRatiox, data[3] * spanRatioy);
      rect.setOrigin(0, 0);
      rect.setStrokeStyle(4, ProgressBar.COLOR_FRONT);
      this.toClean.push(rect);
      rect.setDepth(1000);
      //
    }

    //console.log(lRedraw + " A");
    return lRedraw;
  }

  drawMannequin(data, lClean) {
    let lRedraw = false;
    if (!data) {
      return lRedraw;
    }

    //console.log(data[0]);
    if (!this.lastMannequin) {
      this.lastMannequin = [-1, -1, -1];
    }

    if (data[0][0] !== this.lastMannequin[0] || data[0][1] !== this.lastMannequin[1] || data[0][2] !== this.lastMannequin[2]) {
      this.lastMannequin = [data[0][0], data[0][1], data[0][2]];
      lRedraw = true;
    }

    if (lRedraw) {
      if (lClean) {
        this.clean();
      }
      const a = MainScene.LINES;
      let spanRatiox = 1920 / MainScene.REAL_VIDEO_WIDTH;
      let spanRatioy = 1080 / MainScene.REAL_VIDEO_HEIGHT;

      for (let x = 0; x < a.length; x++) {
        const ref = a[x];
        const p0 = data[MainScene[ref[0]]];
        const p1 = data[MainScene[ref[1]]];
        if (p0[2] !== 0 && p1[2] !== 0) {
          const color = parseInt(MainScene.COLORS[x].slice(1), 16);
          const line = this.add.line(0, 0, p0[0] * spanRatiox, p0[1] * spanRatioy, p1[0] * spanRatiox, p1[1] * spanRatioy, color);
          line.setOrigin(0, 0);
          line.setLineWidth(2);
          this.toClean.push(line);
          line.setDepth(1000 + x);
        }
      }
      for (let x = 0; x < data.length; x++) {
        if (data[x][2] !== 0) {
          const circle = this.add.circle((data[x][0] - 4) * spanRatiox, (data[x][1] - 4) * spanRatioy, 4 * spanRatiox, 0xff0000);
          circle.setOrigin(0, 0);
          this.toClean.push(circle);
          circle.setDepth(1000 + x);
        }
      }
    }
    //console.log(lRedraw + " B");
    return lRedraw;
  }

  clean() {
    for (let x = 0; x < this.toClean.length; x++) {
      this.toClean[x].destroy();
    }
  }

  createButtonStart() {
    this.startButton = this.add.container(0, 0);
    const rect = this.add.rectangle(0, 0, Tracking.WIDTH, Tracking.HEIGHT, ProgressBar.COLOR_FRONT);
    rect.setOrigin(0, 0);
    rect.alpha = 0.5;
    rect.setInteractive();
    this.startButton.add(rect);
    const play = this.add.image(0, 0, "buttonplay");
    this.startButton.add(play);
    play.x = Tracking.WIDTH / 2;
    play.y = Tracking.HEIGHT / 2;
    play.setInteractive({ useHandCursor: true });
    play.setScale(0.25, 0.25);

    play.on("pointerover", this.onOverPlay.bind(this, play));
    play.on("pointerout", this.onOutPlay.bind(this, play));
    play.on("pointerup", this.onPlay.bind(this));
    this.startButton.setDepth(1999);
  }

  onOverPlay(btn) {
    //btn.alpha = 0.75;
  }

  onOutPlay(btn) {
    btn.alpha = 1;
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  onPlay() {
    //if (Tracking.data.videos.length > 1) {
    this.togglecam.visible = true;
    this.togglepanel3d.visible = true;
    if (!Pqp.isNullOrEmpty(this.dataSelected.report)) {
      this.report.visible = true;
    }
    //this.togglepanel3d.visible = false;
    //}
    this.togglePlayPause();
    this.startButton.destroy();
  }

  createLogo() {
    this.logo = this.add.container(0, 0);
    const base = this.add.image(0, 0, "baselogo");
    base.setOrigin(0, 0);
    this.logo.add(base);
    this.logo.x = Tracking.WIDTH - base.width;
    base.setBlendMode(Phaser.BlendModes.MULTIPLY);
    const logo = this.add.image(0, 0, "logoht");
    logo.setOrigin(0, 0);
    this.logo.add(logo);
    this.logo.x = Tracking.WIDTH - base.width;
    this.logo.setDepth(100100);

    this.togglecamDummy = this.add.image(0, 0, "togglecam");
    this.togglecamDummy.setOrigin(0, 0);
    this.togglecamDummy.visible = true;
    this.togglecamDummy.x = 96 + 64;
    this.togglecamDummy.y = Tracking.HEIGHT - 72;
    this.togglecamDummy.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);
    this.togglecamDummy.alpha = 0.5;

    this.togglecam = this.add.container(0, 0);
    const togglecambase = this.add.image(0, 0, "togglecambase");
    togglecambase.setOrigin(0, 0);
    togglecambase.visible = false;
    this.togglecam.add(togglecambase);
    this.togglecambase = togglecambase;
    togglecambase.setBlendMode(Phaser.BlendModes.MULTIPLY);
    const togglecamlogo = this.add.image(0, 0, "togglecam");
    togglecamlogo.setOrigin(0, 0);
    this.togglecam.add(togglecamlogo);
    this.togglecam.setScale(0.5, 0.5);
    this.togglecam.x = 96 + 64;
    this.togglecam.y = Tracking.HEIGHT - 72;
    togglecamlogo.setInteractive({ useHandCursor: true });
    togglecamlogo.on("pointerdown", this.onSwitchTest.bind(this));
    this.togglecam.visible = false;
    this.togglecam.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);

    this.togglepanel3dDummy = this.add.image(0, 0, "toggle3d");
    this.togglepanel3dDummy.setOrigin(0, 0);
    this.togglepanel3dDummy.visible = true;
    this.togglepanel3dDummy.x = 32;
    this.togglepanel3dDummy.y = Tracking.HEIGHT - 72;
    this.togglepanel3dDummy.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);
    this.togglepanel3dDummy.alpha = 0.5;

    this.togglepanel3d = this.add.container(0, 0);
    const togglepanel3dbase = this.add.image(0, 0, "toggle3dbase");
    togglepanel3dbase.setOrigin(0, 0);
    this.togglepanel3d.add(togglepanel3dbase);
    this.togglepanel3dbase = togglepanel3dbase;
    togglepanel3dbase.visible = false;
    togglepanel3dbase.setBlendMode(Phaser.BlendModes.MULTIPLY);
    const togglepanel3dlogo = this.add.image(0, 0, "toggle3d");
    togglepanel3dlogo.setOrigin(0, 0);
    this.togglepanel3d.add(togglepanel3dlogo);
    this.togglepanel3d.x = 32;
    this.togglepanel3d.y = Tracking.HEIGHT - 72;
    togglepanel3dlogo.setInteractive({ useHandCursor: true });
    togglepanel3dlogo.on("pointerdown", this.onShow3D.bind(this));
    this.togglepanel3d.visible = false;
    this.togglepanel3d.setScale(0.5, 0.5);
    this.togglepanel3d.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);

    //this.togglepanel3d.alpha = 1; //0.000001;

    this.reportDummy = this.add.image(0, 0, "report");
    this.reportDummy.setOrigin(0, 0);
    this.reportDummy.visible = true;
    this.reportDummy.x = 32 + 64;
    this.reportDummy.y = Tracking.HEIGHT - 72;
    this.reportDummy.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);
    this.reportDummy.alpha = 0.5;

    this.report = this.add.container(0, 0);
    const reportbase = this.add.image(0, 0, "toggle3dbase");
    reportbase.setOrigin(0, 0);
    this.report.add(reportbase);
    this.reportbase = reportbase;
    reportbase.visible = false;
    reportbase.setBlendMode(Phaser.BlendModes.MULTIPLY);
    const reportlogo = this.add.image(0, 0, "report");
    reportlogo.setOrigin(0, 0);
    this.report.add(reportlogo);
    this.report.x = 32 + 64;
    this.report.y = Tracking.HEIGHT - 72;
    reportlogo.setInteractive({ useHandCursor: true });
    reportlogo.on("pointerdown", this.onShowReport.bind(this));
    this.report.visible = false;
    this.report.setScale(0.5, 0.5);
    this.report.setScale(MainScene.SCALE_CAM_TOGGLE, MainScene.SCALE_CAM_TOGGLE);

    if (Pqp.isNullOrEmpty(this.dataSelected.report)) {
      this.report.visible = false;
    }
  }

  killWidget3D() {
    this.panel3D.killWidget(this.panel3D);
    this.panel3D.kill();
    this.tweenPanelActive = false;
  }

  gox1() {
    if (this.currentSpeed !== 1) {
      this.vid.setPlaybackRate(1);
      this.currentSpeed = 1;
      //this.ui.setNormalMode();
    }
  }

  gox5() {
    if (this.currentSpeed !== 5) {
      this.currentSpeed = 5;
      //this.ui.setSlowedMode();
      this.startSlowPlay();
    }
  }

  gox10() {
    if (this.currentSpeed !== 10) {
      this.currentSpeed = 10;
      //this.ui.setSlowedMode();
      this.startSlowPlay();
    }
  }

  startSlowPlay() {
    //const rate = this.vid.getPlaybackRate();
    //console.log(rate);
    if (this.currentSpeed === 5) {
      this.vid.setPlaybackRate(0.5);
    }
    if (this.currentSpeed === 10) {
      this.vid.setPlaybackRate(0.1);
    }
  }

  createPlayPauseBig() {
    this.bigPlay = this.add.image(0, 0, "buttonplay");
    this.bigPlay.x = Tracking.WIDTH / 2;
    this.bigPlay.y = Tracking.HEIGHT / 2;
    this.bigPlay.setScale(0.5, 0.5);
    this.bigPlay.visible = false;

    this.bigPause = this.add.image(0, 0, "buttonpause");
    this.bigPause.x = Tracking.WIDTH / 2;
    this.bigPause.y = Tracking.HEIGHT / 2;
    this.bigPause.setScale(0.5, 0.5);
    this.bigPause.visible = false;
  }

  createDisabler() {
    const rect = this.add.rectangle(0, 0, Tracking.WIDTH, Tracking.HEIGHT, ProgressBar.COLOR_FRONT);
    rect.setOrigin(0, 0);
    rect.alpha = 0.5;
    rect.setInteractive();
    this.disabler = rect;
    this.disabler.visible = false;
  }

  showDisabler(flag) {
    this.disabler.visible = flag;
    //this.children.bringToTop(this.disabler);
  }

  openLayer(data, lFromAnalisi = false) {
    this.showDisabler(true);
    this.wasPlaying = !this.videoPaused;
    if (this.wasPlaying) {
      this.pauseVideo();
    }

    PagePlayer.that.openLayer(data, lFromAnalisi);
    MainScene.that.ui.setPlayPause(false);
  }

  closedLayer(lFromAnalisi) {
    if (this.wasPlaying) {
      this.resumeVideo();
    }
    this.showDisabler(false);
    if (lFromAnalisi) {
      this.resumeAnalisi();
    }
  }

  checkAnalisi(flag) {
    if (flag) {
      this.startAnalisi();
    } else {
      this.stopAnalisi();
    }
  }

  createDisablerAnalisi() {
    const rect = this.add.rectangle(0, 0, Tracking.WIDTH, Tracking.HEIGHT - 68, 0xff0000);
    rect.setOrigin(0, 0);
    rect.alpha = 0.0001;
    rect.setInteractive();
    this.disablerAnalisi = rect;
    this.disablerAnalisi.visible = false;
  }

  showDisablerAnalisi(flag, all) {
    if (all) {
      this.disablerAnalisi.displayHeight = Tracking.HEIGHT;
    } else {
      this.disablerAnalisi.displayHeight = Tracking.HEIGHT - 68;
    }
    this.disablerAnalisi.visible = flag;
    //this.children.bringToTop(this.disablerAnalisi);
    if (Tracking.data.videos.length > 1) {
      //this.children.bringToTop(this.togglecam);
    }
  }

  startAnalisi() {
    this.togglecam.visible = false;
    this.togglepanel3d.visible = false;
    this.report.visible = false;

    this.performAlreadyShown = [];
    this.showDisablerAnalisi(true);
    this.videoAnalisi = true;
    this.ui.setBar(0, this.getTime(0));
    this.vid.off("seeked");
    this.vid.on("seeked", this.vidoeSeeked.bind(this));
    this.vid.seekTo(0);
    if (this.videoPaused) {
      this.resumeVideo();
    }
  }

  stopAnalisi() {
    this.togglecam.visible = true;
    this.togglepanel3d.visible = true;
    if (!Pqp.isNullOrEmpty(this.dataSelected.report)) {
      this.report.visible = true;
    }

    this.showDisablerAnalisi(false);
    this.videoAnalisi = false;
    console.log("Stop");
  }

  checkIfShowPerform() {
    let time = this.vid.getCurrentTime();
    time = Math.floor(time * 10) * 100;
    const a = this.dataSelected.data[3];
    let el = null;
    for (let x = 0; x < a.length; x++) {
      if (a[x].time === time) {
        if (this.performAlreadyShown.indexOf(a[x].time) < 0) {
          el = a[x];
          this.performAlreadyShown.push(a[x].time);
        }
        break;
      }
    }

    if (el) {
      this.pauseVideo();
      const { points } = this.ui.progressBar;
      for (let x = 0; x < points.length; x++) {
        if (points[x].data.time === el.time) {
          this.ui.progressBar.onOverPoint(points[x].data, points[x].point, points[x].container);
          this.idResume = this.time.delayedCall(MainScene.TIME_TOOLTIP_ANALISI, this.showAnalisiCompleta.bind(this, points[x]));
          break;
        }
      }
    }
  }

  showAnalisiCompleta(point) {
    //console.log(point);
    //this.ui.progressBar.removePanel();
    this.openLayer(point.data, true);
  }

  resumeAnalisi(point) {
    this.ui.progressBar.onOutPoint();
    this.resumeVideo();
  }

  onSwitchTest(e) {
    if (!this.panelCameras) {
      this.panelCameras = new PanelCameras(this, this.handlePanelCameraEvents.bind(this));
      this.panelCameras.init();
      this.add.existing(this.panelCameras);
      this.panelCameras.x = Tracking.WIDTH; // - this.panelCameras.width;
      this.panelCameras.setDepth(20000);
      this.statusPanel = 0;
      this.panelCameras.setScale(MainScene.SCALE_PANEL, MainScene.SCALE_PANEL);
    }

    this.panelCameras.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;

    let videoWasPaused;
    if (this.statusPanel === 0) {
      videoWasPaused = this.videoPaused;
      this.panelCameras.videoWasPaused = videoWasPaused;
      if (!this.videoPaused) {
        this.pauseVideo();
      }
    }

    //this.togglecam.x = this.togglecam.y = Math.floor((Tracking.HEIGHT - UiInterface.HEIGHT - togglecambase.height) / 2);

    if (this.statusPanel === 0) {
      // Apre
      this.togglepanel3d.visible = false;
      this.report.visible = false;
      this.showDisablerAnalisi(true, true);
      this.disablerAnalisi.on("pointerup", this.onSwitchTest.bind(this));
    } else {
      // Chiude
      this.disablerAnalisi.off("pointerup");
      this.togglepanel3d.visible = true;
      if (!Pqp.isNullOrEmpty(this.dataSelected.report)) {
        this.report.visible = true;
      }
      this.showDisablerAnalisi(false);
      if (!this.panelCameras.videoWasPaused) {
        this.resumeVideo();
      }
    }

    this.tweenPanelActive = true;
    if (this.statusPanel === 1) {
      // Close
      this.statusPanel = 0;
      this.tweens.add({
        targets: this.panelCameras,
        x: Tracking.WIDTH,
        alpha: 1,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, false, false),
      });
      /*this.tweens.add({
        targets: this.togglecam,
        x: Tracking.WIDTH - this.togglecambase.width * MainScene.SCALE_CAM_TOGGLE,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, false),
      });*/
    } else {
      // Open
      this.statusPanel = 1;
      this.tweens.add({
        targets: this.panelCameras,
        x: Tracking.WIDTH - this.panelCameras.width * MainScene.SCALE_PANEL,
        alpha: 1,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, true, false),
      });
      /*this.tweens.add({
        targets: this.togglecam,
        x: Tracking.WIDTH - this.togglecambase.width * MainScene.SCALE_CAM_TOGGLE - this.panelCameras.width * MainScene.SCALE_PANEL,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, true),
      });*/
    }
  }

  onCloseReport() {
    this.reportOpened = false;
    this.panelReportHtml.remove();
    jQuery("html").css("overflow", "auto");
    this.showDisabler(false);
  }

  onShowReport() {
    this.reportOpened = true;
    this.pauseVideo();
    this.showDisabler(true);
    jQuery("html").css("overflow", "hidden");

    const outerDiv = jQuery("<div></div>");
    outerDiv.css({
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      "z-index": 10000000,
    });

    const div = jQuery("<div></div>");
    div.css({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      "background-color": "rgba(0,0,0,0.5)",
      "z-index": 1,
    });
    jQuery(outerDiv).append(div);
    jQuery(".video-holder").append(outerDiv);
    div.on("click", this.onCloseReport.bind(this));

    this.panelReportHtml = outerDiv;

    this.content = jQuery("<div></div>");
    this.content.css({
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "80%",
      height: "80%",

      transform: "translate(-50%, -50%)",
      "background-color": "white",
      padding: "16px",
      "border-radius": "8px",
      "z-index": 2,
      "overflow-y": "scroll",
    });
    jQuery(outerDiv).append(this.content);
    //debugger;
    const url = "/Pages/getreportpdf.aspx?Uid=" + Tracking.appConfig.uidReport;
    // legge l'html as is dall'url
    jQuery.get(url, this.onReportLoaded.bind(this));

    // Close button
    const close = jQuery("<div></div>");
    const img = "/dist/assets/close-btn-icon.svg";
    close.css({
      position: "absolute",
      top: "10%",
      right: "7.5%",
      width: "24px",
      height: "24px",
      cursor: "pointer",
      "z-index": 3,
      "background-color": "white",
      "border-radius": "50%",
    });
    close.html(`<img src="${img}" style="width: 50%; height: 50%; margin: 25%;">`);
    close.on("click", this.onCloseReport.bind(this));
    jQuery(outerDiv).append(close);

    return;
    /*
    if (!this.panelReport) {
      //console.log(videoWasPaused);
      this.panelReport = new PanelReport(this, this.handlePanelReportEvents.bind(this));
      this.panelReport.init();
      this.add.existing(this.panelReport);
      this.panelReport.x = Math.floor((Tracking.WIDTH - this.panelReport.width * MainScene.SCALE_PANEL) / 2);
      this.panelReport.y = -this.panelReport.height * MainScene.SCALE_PANEL;
      this.panelReport.setDepth(20000);
      this.statusReport = 0;
      this.panelReport.setScale(MainScene.SCALE_PANEL, MainScene.SCALE_PANEL);
    }

    this.panelReport.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;

    let videoWasPaused;
    if (this.statusReport === 0) {
      videoWasPaused = this.videoPaused;
      this.panelReport.videoWasPaused = videoWasPaused;
      if (!this.videoPaused) {
        this.pauseVideo();
      }
    }

    if (this.statusReport === 0) {
      // Apre

      this.togglepanel3d.visible = false;
      this.togglecam.visible = false;
      this.showDisablerAnalisi(true, true);
      this.disablerAnalisi.on("pointerup", this.onShowReport.bind(this));
    } else {
      // Chiude
      this.disablerAnalisi.off("pointerup");
      this.togglepanel3d.visible = true;
      this.togglecam.visible = true;
      this.showDisablerAnalisi(false);
      if (!this.panelReport.videoWasPaused) {
        this.resumeVideo();
      }
    }

    //this.togglecam.x = this.togglecam.y = Math.floor((Tracking.HEIGHT - UiInterface.HEIGHT - togglecambase.height) / 2);

    this.tweenPanelActive = true;
    if (this.statusReport === 1) {
      // Close
      this.panelReport.showScrollablePanel(false);
      this.statusReport = 0;
      this.tweens.add({
        targets: this.panelReport,
        y: -this.panelReport.height * MainScene.SCALE_PANEL,
        alpha: 1,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, false, true),
      });
    } else {
      // Apre
      this.statusReport = 1;
      this.tweens.add({
        targets: this.panelReport,
        y: 0,
        alpha: 1,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, false, true, true),
      });
    }*/
  }

  onReportLoaded(data) {
    //this.content.html(data);
    const shadowHost = this.content.get(0);
    let shadowRoot = shadowHost.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = data;
  }

  onShow3D() {
    /*let videoWasPaused;
    if (this.status3D === 0) {
      videoWasPaused = this.videoPaused;
      if (!this.videoPaused) {
        this.pauseVideo();
      }
    }*/

    if (this.status3D === 0) {
      // Apre
      this.showDisablerAnalisi(true, true);
      this.togglecam.visible = false;
      this.report.visible = false;
      this.disablerAnalisi.on("pointerup", this.onShow3D.bind(this));
    } else {
      // Chiude
      this.disablerAnalisi.off("pointerup");
      this.showDisablerAnalisi(false);
      this.togglecam.visible = true;
      if (!Pqp.isNullOrEmpty(this.dataSelected.report)) {
        this.report.visible = true;
      }
      if (!this.panel3D.videoWasPaused) {
        this.resumeVideo();
      }
    }

    if (!this.panel3D) {
      //console.log(videoWasPaused);
      this.panel3D = new Panel3D(this, this.handlePanelCameraEvents.bind(this));
      this.panel3D.init();
      this.add.existing(this.panel3D);
      this.panel3D.x = -this.panel3D.width * MainScene.SCALE_PANEL;
      this.panel3D.setDepth(20001);
      this.status3D = 0;
      this.panel3D.setScale(MainScene.SCALE_PANEL, MainScene.SCALE_PANEL);
    }

    let videoWasPaused;
    if (this.status3D === 0) {
      videoWasPaused = this.videoPaused;
      this.panel3D.videoWasPaused = videoWasPaused;
      if (!this.videoPaused) {
        this.pauseVideo();
      }
    }

    this.panel3D.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;

    //this.togglecam.x = this.togglecam.y = Math.floor((Tracking.HEIGHT - UiInterface.HEIGHT - togglecambase.height) / 2);

    this.tweenPanelActive = true;
    if (this.status3D === 1) {
      // Close
      this.status3D = 0;
      this.tweens.add({
        targets: this.panel3D,
        x: -this.panel3D.width * MainScene.SCALE_PANEL,
        alpha: 1,
        duration: 150,
        onStart: this.killWidget3D.bind(this),
      });
      /*this.tweens.add({
        targets: this.togglepanel3d,
        x: 0,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, true, true),
        onStart: this.killWidget3D.bind(this),
      });*/
    } else {
      // Apre
      this.status3D = 1;
      this.tweens.add({
        targets: this.panel3D,
        x: 0,
        alpha: 1,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, true, false, false),
      });
      /*this.tweens.add({
        targets: this.togglepanel3d,
        x: this.panel3D.width * MainScene.SCALE_PANEL,
        duration: 150,
        onComplete: this.tweenCompleted.bind(this, true, false),
      });*/
    }
  }

  handlePanelReportEvents(e) {}

  tweenCompleted(isPanel3D, lClosed, lPanelReport) {
    this.tweenPanelActive = false;
    if (isPanel3D) {
      if (!lClosed) {
        this.panel3D.showWidget(this.dataSelected.data[4][this.lastToShow]);
      } else {
        this.panel3D = null;
      }
    }

    if (lPanelReport) {
      if (lClosed) {
        this.panelReport.showScrollablePanel(true);
      } else {
        this.panelReport.showScrollablePanel(false);
      }
    }
  }

  handlePanelCameraEvents(e) {
    if (e.type === PanelCameras.EVENT_CHANGE_CAMERA) {
      this.toggleVideo(e.data.id);
    }
  }

  toggleVideo(camid) {
    if (this.pressedSwitch) {
      return;
    }
    this.pressedSwitch = true;

    /*this.selected++;
    if (this.selected >= Tracking.data.videos.length) {
      this.selected = 0;
    }*/

    let index = 0;
    for (let x = 0; x < Tracking.data.videos.length; x++) {
      if (Tracking.data.videos[x].camid === camid) {
        index = x;
        break;
      }
    }
    this.selected = index;
    //console.log(camid);

    this.alreadyPaused = false;
    if (this.videoPaused) {
      this.alreadyPaused = true;
    }

    this.pauseVideo();

    //console.log("--------->" + this.selected);
    this.setSelectedVideo(this.selected);
    this.panelCameras.updateCam();
    this.showDisabler(true);
    this.loading.visible = true;
    this.txtWait.visible = true;
    this.txtWait.setText(Locale.g("loading"));
    //this.children.bringToTop(this.loading);
    //this.children.bringToTop(this.txtWait);
    if (this.vid.alpha === 1) {
      this.vid.alpha = 0.1;
      this.alreadyAlphed = false;
    } else {
      this.alreadyAlphed = true;
    }

    if (!Tracking.data.videos[this.selected].cached) {
      Tracking.data.videos[this.selected].cached = true;
      this.load.video("camera" + this.selected, Tracking.data.videos[this.selected].url, "canplay", false, false);
      this.load.once("complete", this.onNewVideoReady.bind(this));
      this.load.start();
    } else {
      this.onNewVideoReady();
    }
  }

  OLDtoggleVideo() {
    if (this.pressedSwitch) {
      return;
    }
    this.pressedSwitch = true;

    this.selected++;
    if (this.selected >= Tracking.data.videos.length) {
      this.selected = 0;
    }

    this.alreadyPaused = false;
    if (this.videoPaused) {
      this.alreadyPaused = true;
    }

    this.pauseVideo();

    this.setSelectedVideo(this.selected);
    this.showDisabler(true);
    this.loading.visible = true;
    this.txtWait.visible = true;
    this.txtWait.setText(Locale.g("loading"));
    //this.children.bringToTop(this.loading);
    //this.children.bringToTop(this.txtWait);
    if (this.vid.alpha === 1) {
      this.vid.alpha = 0.1;
      this.alreadyAlphed = false;
    } else {
      this.alreadyAlphed = true;
    }

    if (!Tracking.data.videos[this.selected].cached) {
      Tracking.data.videos[this.selected].cached = true;
      this.load.video("camera" + this.selected, Tracking.data.videos[this.selected].url, "canplay", false, false);
      this.load.once("complete", this.onNewVideoReady.bind(this));
      this.load.start();
    } else {
      this.onNewVideoReady();
    }
  }

  onNewVideoReady() {
    const perc = this.vid.getCurrentTime() / this.vid.getDuration();

    /*    this.selected++;
    if (this.selected >= Tracking.data.videos.length) {
      this.selected = 0;
    }

    this.setSelectedVideo(this.selected);*/

    this.vid.changeSource("camera" + this.selected, true);
    this.vid.off("seeked");
    this.vid.on("seeked", this.vidoeSeekedAfterChange.bind(this));
    this.vid.seekTo(perc);
    this.drawData();
    /*    this.showDisabler(true);
    this.loading.visible = true;
    this.children.bringToTop(this.loading);*/

    //let p = this.load.video("match1", this.dataSelected.url, "canplay", false, false);
    //p.on("canplay", this.suca.bind(this));
    //console.log(p);
    //this.vid.loadURL(this.dataSelected.url);
  }

  vidoeSeekedAfterChange() {
    if (!this.alreadyAlphed) {
      this.vid.alpha = 1;
    }
    this.vid.off("seeked");
    this.showDisabler(false);
    this.loading.visible = false;
    this.txtWait.visible = false;

    if (this.currentSpeed === 1) {
      this.vid.setPlaybackRate(1);
    }

    if (this.currentSpeed === 5) {
      this.vid.setPlaybackRate(0.5);
    }
    if (this.currentSpeed === 10) {
      this.vid.setPlaybackRate(0.1);
    }

    if (!this.alreadyPaused) {
      this.resumeVideo();
      this.drawData();
    } else {
      //if (this.videoPaused) {
      this.pauseVideo();
      this.drawData();
    }
    this.pressedSwitch = false;
  }

  setupPloty() {
    const trace1 = {
      x: [1, 2, 3, 4],
      y: [10, 15, 13, 17],
      z: [10, 15, 13, 107],
      mode: "markers",
      type: "scatter3d",
      name: "Team B",
      text: ["B-a", "B-b", "B-c", "B-d", "B-e"],
      textfont: {
        family: "Times New Roman",
      },
      textposition: "bottom center",
      marker: { size: 12 },
    };

    const trace2 = {
      x: [2, 3, 4, 5],
      y: [16, 5, 11, 9],
      z: [10, 15, 103, 17],
      mode: "lines",
      type: "scatter3d",
    };

    const trace3 = {
      x: [1, 2, 3, 4],
      y: [12, 9, 15, 12],
      z: [100, 15, 13, 17],
      mode: "lines+markers",
      type: "scatter3d",
    };

    const data = [trace1, trace2, trace3];

    const layout = {
      xaxis: {
        range: [0.75, 5.25],
      },
      yaxis: {
        range: [0, 8],
      },
      legend: {
        y: 0.5,
        yref: "paper",
        font: {
          family: "Arial, sans-serif",
          size: 20,
          color: "grey",
        },
      },
      title: "Data Labels on the Plot",
    };

    Plotly.newPlot("myDiv", data, layout);
  }

  writeStats(data, box) {
    //return;

    if (!this.flagStats) {
      this.stats.visible = false;

      return;
    }

    if (!data) {
      this.stats.visible = false;
      return;
    }
    const a = data[1];

    if (!this.stats) {
      this.stats = this.add.container(0, 0);
    }
    for (let x = 0; x < this.singleStats.length; x++) {
      this.singleStats[x].destroy();
    }
    if (this.statsRect) {
      this.statsRect.destroy();
      this.statsRect = null;
    }

    this.singleStats = [];
    const hasData = !(Object.keys(a).length === 0 && a.constructor === Object);

    if (hasData > 0) {
      this.stats.visible = true;
      let h = 0;
      let w = 0;
      for (const name in a) {
        // Crea la singola entry
        const txt = this.add.text(0, h, name + ": " + Math.round(a[name]) + "°", {
          fontFamily: "DIN Next LT Pro",
          fontWeight: 200,
          fontSize: "26px",
          color: this.toHexColor(ProgressBar.COLOR_BACK),
          align: "left",
        });
        h += txt.displayHeight;
        if (txt.displayWidth > w) {
          w = txt.displayWidth;
        }
        txt.destroy();
      }
      //console.log(w, h);
      //this.statsRect.displayWidth = w;
      //this.statsRect.displayheight = h;
      this.statsRect = this.add.rectangle(0, 0, w + 32, h + 32, ProgressBar.COLOR_FRONT);
      this.statsRect.setOrigin(0, 0);
      this.stats.add(this.statsRect);
      this.statsRect.setBlendMode(Phaser.BlendModes.MULTIPLY);

      h = 0;
      for (const name in a) {
        // Crea la singola entry
        const txt = this.add.text(16, h + 16, name + ": " + Math.round(a[name]) + "°", {
          fontFamily: "DIN Next LT Pro",
          fontWeight: 200,
          fontSize: "26px",
          color: this.toHexColor(ProgressBar.COLOR_BACK),
          align: "left",
        });
        h += txt.displayHeight;
        this.stats.add(txt);
        this.singleStats.push(txt);
      }
      //console.log(this.selected);

      let spanRatiox = 1920 / MainScene.REAL_VIDEO_WIDTH;
      let spanRatioy = 1080 / MainScene.REAL_VIDEO_HEIGHT;

      if (!Tracking.data.videos[this.selected].leftSide) {
        this.stats.x = (box[0] + box[2]) * spanRatiox + 100;
        this.stats.y = box[1] * spanRatioy;
      } else {
        this.stats.x = box[0] * spanRatiox - w - 100;
        this.stats.y = box[1] * spanRatioy;
      }
    } else {
      this.stats.visible = false;
    }
  }

  writeStats2(percentRespectTotaltime) {
    if (!this.flagStats) {
      return;
    }
    let titClip;
    let rectClip;

    // Fotogramma corrente
    const duration = MainScene.that.vid.getDuration();
    const time = duration * percentRespectTotaltime;
    let frame = time * MainScene.FPS;
    frame = Math.round(frame);

    if (this.statPanel) {
      this.statPanel.destroy();
      this.statPanel = null;
    }
    // controlla se esista quella statistica
    let lNoData = false;
    //debugger;
    if (this.dataSelected.data[6]["f" + frame]) {
      //debugger;
      // Crea il panello
      this.statPanel = this.add.container(0, 0);
      // Craa il contenitore per le entries
      const cont = this.add.container(0, 0);
      //this.statPanel.add(cont);
      const o = this.dataSelected.data[6]["f" + frame];
      // crea le entries
      let posy = 0;
      let maxw = 0;
      let maxwr = 0;
      const toArrange = [];
      //debugger;
      let count = 0;

      // Devo sortare o.data su o.data[x].meta.order
      //debugger;
      o.data.sort((a, b) => {
        return a.meta.order - b.meta.order;
      });

      for (let x = 0; x < o.data.length; x++) {
        if (o.data[x].type > 0) {
          //let color = 0xff2400;
          let color = Tracking.REDDONE;
          if (o.data[x].type === 2) {
            color = 0xffffff;
          }
          //debugger;

          let toPrintName = o.data[x].meta.name;
          //debugger;
          if (o.data[x].min_t_print !== "" && o.data[x].max_t_print !== "") {
            toPrintName += " (" + o.data[x].min_t_print + "/" + o.data[x].max_t_print + ")";
          } else if (o.data[x].min_t_print !== "") {
            toPrintName += " (" + o.data[x].min_t_print + ")";
          } else if (o.data[x].max_t_print !== "") {
            toPrintName += " (" + o.data[x].max_t_print + ")";
          }
          //console.log(toPrintName);

          let toPrint = o.data[x].valuePrint;
          /*if (o.data[x].max_t_print !== "" && o.data[x].max_t_print !== "") {
            toPrint += " (" + o.data[x].min_t_print + "/" + o.data[x].max_t_print + ")";
          }*/

          const txtLeft = this.add.text(0, 0, toPrintName, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(color) });
          cont.add(txtLeft);
          const txtRight = this.add.text(0, 0, toPrint, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(color) });
          cont.add(txtRight);

          txtLeft.y = posy;
          txtRight.y = posy;
          toArrange.push({ clip: txtRight, overData: o.data[x] });
          if (txtLeft.displayWidth > maxw) {
            maxw = txtLeft.displayWidth;
          }
          if (txtRight.displayWidth > maxwr) {
            maxwr = txtRight.displayWidth;
          }

          posy += txtLeft.displayHeight - 2;
          count++;

          /*toArrange[x].x = maxw + 16 + maxwr - toArrange[x].displayWidth;
          const rectInteractive = this.add.rectangle(0, 0, maxw + maxwr + 16, toArrange[x].displayHeight, ProgressBar.COLOR_FRONT);
          rectInteractive.setOrigin(0, 0);
          rectInteractive.setInteractive({ useHandCursor: true });
          rectInteractive.on("pointerover", this.onOverRect.bind(this, rectInteractive, o.data[x]));
          rectInteractive.on("pointerout", this.onOutRect.bind(this, rectInteractive, o.data[x]));
          rectInteractive.x = 0;
          rectInteractive.y = toArrange[x].y;
          rectInteractive.alpha = 0.000001;
          cont.add(rectInteractive);*/
        }
      }

      for (let x = 0; x < toArrange.length; x++) {
        toArrange[x].clip.x = maxw + 16 + maxwr - toArrange[x].clip.displayWidth;
        const rectInteractive = this.add.rectangle(0, 0, maxw + maxwr + 16, toArrange[x].clip.displayHeight, ProgressBar.COLOR_FRONT);
        rectInteractive.setOrigin(0, 0);
        rectInteractive.setInteractive({ useHandCursor: true });
        //rectInteractive.on("pointerover", this.onOverRect.bind(this, rectInteractive, o.data[x]));
        //rectInteractive.on("pointerout", this.onOutRect.bind(this, rectInteractive, o.data[x]));
        rectInteractive.on("pointerover", this.onOverRect.bind(this, rectInteractive, toArrange[x].overData));
        rectInteractive.on("pointerout", this.onOutRect.bind(this, rectInteractive, toArrange[x].overData));
        rectInteractive.x = 0;
        rectInteractive.y = toArrange[x].clip.y;
        rectInteractive.alpha = 0.000001;
        cont.add(rectInteractive);
      }

      if (count > 0) {
        // Titolo
        const txtTitle = this.add.text(16, 16, Locale.g("statsTitle"), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });
        this.statPanel.add(txtTitle);
        titClip = txtTitle;

        // crea il background
        const graphics = this.add.graphics();
        graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
        graphics.fillRect(0, 0, maxw + maxwr + 48, posy + 32 + txtTitle.displayHeight + 8);
        this.statPanel.add(graphics);
        rectClip = graphics;

        this.statPanel.width = maxw + maxwr + 48;
        this.statPanel.height = posy + 32 + txtTitle.displayHeight + 8;

        rectClip = this.add.rectangle(0, 0, this.statPanel.width, titClip.y + titClip.displayHeight, ProgressBar.COLOR_FRONT);
        rectClip.setOrigin(0, 0);
        rectClip.alpha = 0.000001;
        this.statPanel.add(rectClip);

        // Aggiunge il contenitore al panello
        this.statPanel.add(cont);
        cont.x = 16;
        cont.y = 16 + txtTitle.displayHeight + 8;
        this.statPanel.bringToTop(txtTitle);

        // Posiziona il panello
        //this.statPanel.x = 16;
        //this.statPanel.y = 360;
      } else {
        lNoData = true;
      }
    } else {
      lNoData = true;
    }

    if (lNoData) {
      this.statPanel = this.add.container(0, 0);
      // Titolo
      const txtTitle = this.add.text(16, 16, Locale.g("statsTitle"), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });
      this.statPanel.add(txtTitle);
      titClip = txtTitle;

      // Testo no info
      const txtNoInfo = this.add.text(16, 8 + txtTitle.displayHeight + 16, Locale.g("noInfo"), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });
      this.statPanel.add(txtNoInfo);

      // crea il background
      const graphics = this.add.graphics();
      graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
      graphics.fillRect(0, 0, txtNoInfo.displayWidth + 64, txtNoInfo.displayHeight + 32 + txtTitle.displayHeight + 8);
      this.statPanel.add(graphics);

      this.statPanel.width = txtNoInfo.displayWidth + 32;
      this.statPanel.height = txtNoInfo.displayHeight + 32 + txtTitle.displayHeight + 8;

      rectClip = this.add.rectangle(0, 0, this.statPanelwidth, titClip.y + titClip.displayHeight + 8, ProgressBar.COLOR_FRONT);
      rectClip.setOrigin(0, 0);
      rectClip.alpha = 0.000001;
      this.statPanel.add(rectClip);
      //console.log(this.statPanel.width, this.statPanel.height);

      // Posiziona il panello
      //this.statPanel.x = 16;
      //this.statPanel.y = 360;

      this.statPanel.bringToTop(txtTitle);
      this.statPanel.bringToTop(txtNoInfo);
    }

    // Posiziona il panello
    if (this.statPanel) {
      this.statPanel.x = 16;
      this.statPanel.y = 360;
    }

    if (rectClip) {
      rectClip.setInteractive({ useHandCursor: true });
      rectClip.on("pointerup", this.overAll.bind(this));
    }

    this.writeBallVelocity(frame);
  }

  overAll() {
    this.statPanel.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;
  }

  onOverRect(rect, data, e) {
    //console.log(data);
    // crea un tooltip con le spiegazioni sopra
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
    this.tooltip = this.add.container(0, 0);
    // Crea il titolo
    const txtTitle = this.add.text(16, 16, data.meta.name, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });
    this.tooltip.add(txtTitle);
    let posy = 16 + txtTitle.displayHeight + 8;
    // Crea la entry
    const txtEntry = this.add.text(16, 16 + txtTitle.displayHeight + 8, data.meta.desc, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff), fixedWidth: 500 - 32, wordWrap: { width: 500 - 32 } });
    this.tooltip.add(txtEntry);
    posy += txtEntry.displayHeight + 8;

    let txtEntry2;
    if (data.type !== 2) {
      if (!Pqp.isNullOrEmpty(data.meta.solution)) {
        // Crea la entry
        /*txtEntry2 = this.add.text(16, 16 + txtTitle.displayHeight + 8 + txtEntry.displayHeight + 8, data.meta.solution, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff), fixedWidth: 500 - 32, wordWrap: { width: 500 - 32 }, color: "#00FF00" });
        this.tooltip.add(txtEntry2);
        posy += txtEntry2.displayHeight + 8;*/
      }
    }
    posy += 16;

    // Crea il background
    const graphics = this.add.graphics();
    graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
    //graphics.fillRect(0, 0, 500, txtEntry2.displayHeight + 32 + txtTitle.displayHeight + 8);
    graphics.fillRect(0, 0, 500, posy);
    this.tooltip.addAt(graphics, 0);

    const w = 500;

    // Posiziona il tooltip
    this.tooltip.x = this.statPanel.x + rect.x + rect.displayWidth + 48;
    this.tooltip.y = this.statPanel.y + rect.y + rect.displayHeight / 2 - 54;

    if (this.tooltip.x + w + 16 > Tracking.WIDTH) {
      this.tooltip.x = Tracking.WIDTH - w - 16;
    }

    if (this.tooltip.y < 0) {
      this.tooltip.y = 0;
    }
    this.tooltip.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;
  }

  onOutRect(rect, data, e) {
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  }

  writeBallVelocity(frame) {
    if (!this.ballVelocity) {
      // Crea il pannello
      this.ballVelocity = this.add.container(0, 0);
      // Crea il background
      const graphics = this.add.graphics();
      graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
      graphics.fillRect(0, 0, 160, 108);
      this.ballVelocity.add(graphics);
      // Crea il titolo
      const txtTitle = this.add.text(16, 16, Locale.g("ballSpeedTitle"), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });
      this.ballVelocity.add(txtTitle);
      // Crea la entry
      this.txtBallVelocity = this.add.text(16, 16 + txtTitle.displayHeight + 8, "0 " + Locale.g("velocityUnit"), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(0xffffff) });

      this.ballVelocity.add(this.txtBallVelocity);
      this.ballVelocity.x = Tracking.WIDTH - 160 - 16;
      this.ballVelocity.y = 600;
    }

    const a = this.dataSelected.data[3];
    //console.log(a);
    let lFound = false;
    for (let x = 0; x < a.length; x++) {
      if (frame >= a[x].start_frame_idx && frame <= a[x].end_frame_idx) {
        let velInms = a[x].median_velocity;
        let velInKmh = velInms * 3.6;
        this.txtBallVelocity.setText(velInKmh.toFixed(2) + " " + Locale.g("velocityUnit"));
        lFound = true;
        break;
      }
    }
    if (!lFound) {
      this.txtBallVelocity.setText("-");
    }
  }
}
MainScene.that = null;

MainScene.nose = 0;
MainScene.eye_l = 1;
MainScene.eye_r = 2;
MainScene.ear_l = 3;
MainScene.ear_r = 4;
MainScene.sho_l = 5;
MainScene.sho_r = 6;
MainScene.elb_l = 7;
MainScene.elb_r = 8;
MainScene.wri_l = 9;
MainScene.wri_r = 10;
MainScene.hip_l = 11;
MainScene.hip_r = 12;
MainScene.kne_l = 13;
MainScene.kne_r = 14;
MainScene.ank_l = 15;
MainScene.ank_r = 16;

MainScene.LINES = [
  ["nose", "eye_l"],
  ["eye_l", "eye_r"],
  ["eye_r", "nose"],
  ["eye_l", "ear_l"],
  ["eye_r", "ear_r"],
  ["ear_l", "sho_l"],
  ["ear_r", "sho_r"],
  ["sho_l", "sho_r"],
  ["sho_l", "hip_l"],
  ["sho_r", "hip_r"],
  ["hip_l", "hip_r"],
  ["sho_l", "elb_l"],
  ["elb_l", "wri_l"],
  ["sho_r", "elb_r"],
  ["elb_r", "wri_r"],
  ["hip_l", "kne_l"],
  ["kne_l", "ank_l"],
  ["hip_r", "kne_r"],
  ["kne_r", "ank_r"],
];

MainScene.COLORS = ["#d3d3d3", "#2f4f4f", "#2e8b57", "#800000", "#808000", "#00008b", "#ff4500", "#ffa500", "#ffff00", "#7fff00", "#00fa9a", "#4169e1", "#00ffff", "#00bfff", "#0000ff", "#ff00ff", "#f0e68c", "#fa8072", "#dda0dd", "#ff1493"];

MainScene.images = [
  {
    id: "play",
    url: "../dist-player/assets/ui/play.png",
  },
  {
    id: "lens",
    url: "../dist-player/assets/ui/lens.png",
  },
  {
    id: "close",
    url: "../dist-player/assets/ui/close.png",
  },
  {
    id: "pause",
    url: "../dist-player/assets/ui/pause.png",
  },
  {
    id: "fullon",
    url: "../dist-player/assets/ui/fullon.png",
  },
  {
    id: "fulloff",
    url: "../dist-player/assets/ui/fulloff.png",
  },
  {
    id: "ok",
    url: "../dist-player/assets/ui/ok.png",
  },
  {
    id: "ko",
    url: "../dist-player/assets/ui/ko.png",
  },
  {
    id: "info_0",
    url: "../dist-player/assets/ui/info_0.png",
  },
  {
    id: "info_1",
    url: "../dist-player/assets/ui/info_1.png",
  },
  {
    id: "info_2",
    url: "../dist-player/assets/ui/info_2.png",
  },
  {
    id: "playBig",
    url: "../dist-player/assets/ui/playBig.png",
  },
  {
    id: "baselogo",
    url: "../dist-player/assets/ui/baselogo.png",
  },
  {
    id: "logoht",
    url: "../dist-player/assets/ui/logoht.png",
  },
  {
    id: "logosmall",
    url: "../dist-player/assets/ui/logoSmall.png",
  },
  {
    id: "buttonplay",
    url: "../dist-player/assets/ui/button-play.png",
  },
  {
    id: "buttonpause",
    url: "../dist-player/assets/ui/button-pause.png",
  },
  {
    id: "togglecam",
    url: "../dist-player/assets/ui/togglecam.png",
  },
  {
    id: "report",
    url: "../dist-player/assets/ui/report.png",
  },
  {
    id: "togglecambase",
    url: "../dist-player/assets/ui/togglecambase.png",
  },
  {
    id: "fieldBack",
    url: "../dist-player/assets/ui/fieldBack.png",
  },
  {
    id: "fieldReport",
    url: "../dist-player/assets/ui/reportBack.png",
  },
  {
    id: "back3d",
    url: "../dist-player/assets/ui/back3d.png",
  },
  {
    id: "field",
    url: "../dist-player/assets/ui/field.png",
  },
  {
    id: "player",
    url: "../dist-player/assets/ui/player.png",
  },
  {
    id: "toggle3dbase",
    url: "../dist-player/assets/ui/toggle3dbase.png",
  },
  {
    id: "toggle3d",
    url: "../dist-player/assets/ui/toggle3d.png",
  },
  {
    id: "fake",
    url: "../dist-player/assets/ui/fake.png",
  },
];

MainScene.tiles = [
  {
    id: "cam1",
    url: "../dist-player/assets/ui/cam1.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam2",
    url: "../dist-player/assets/ui/cam2.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam3",
    url: "../dist-player/assets/ui/cam3.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam4",
    url: "../dist-player/assets/ui/cam4.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam5",
    url: "../dist-player/assets/ui/cam5.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam6",
    url: "../dist-player/assets/ui/cam6.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam7",
    url: "../dist-player/assets/ui/cam7.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam8",
    url: "../dist-player/assets/ui/cam8.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
  {
    id: "cam9",
    url: "../dist-player/assets/ui/cam9.png",
    config: {
      frameWidth: 771,
      frameHeight: 1080,
    },
  },
];

MainScene.TIME_TOOLTIP_ANALISI = 2000;
MainScene.TIME_ANALISI_VISIBILE = 4000;
MainScene.SCALE_PANEL = 1;
//MainScene.SCALE_PANEL = 0.823;
//MainScene.SCALE_PANEL = 0.932;
MainScene.SCALE_CAM_TOGGLE = 0.75;
// Questi dati dovrebbero poi essere presi da fuori
MainScene.FPS = 50;
MainScene.REAL_VIDEO_WIDTH = 2688;
MainScene.REAL_VIDEO_HEIGHT = 1512;
MainScene.ZINDEX = 100000000;
